import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, useTheme, Avatar } from '@material-ui/core';
import { AttachMoney } from '@material-ui/icons';
import { IdeaCss } from '../IdeaCss';
import { masker } from '../../../helpers';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function IdeaFinancialReturn() {
  const theme = useTheme();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { hasIdeaFlux } = useIdeaDetailsController();

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.card}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <AttachMoney style={{ fill: theme.palette.primary.main }} />
              </Avatar>
              <Typography variant="subtitle1">{t('retorno_financeiro')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={4}>
                <Typography variant="subtitle2">{t('custos_previstos')}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2">{t('retorno_previsto')}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={4} display="flex" alignItems="center">
              <Grid item xs={4}>
                {hasIdeaFlux?.estimatedExecutionCost && (
                  <Typography variant="body2">
                    {masker(hasIdeaFlux.estimatedExecutionCost.toFixed(2))}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={4}>
                {hasIdeaFlux?.estimatedFinancialReturn && (
                  <Typography variant="body2">
                    {masker(hasIdeaFlux.estimatedFinancialReturn.toFixed(2))}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
